let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("boJ01")).then(() => parcelRequire('7RDR5'));